import { Search,X } from "lucide-react";
import React, { useEffect,useState } from 'react';

interface MaoItem {
  nome: string;
  quantidade: number;
}
interface EquipItem {
  nome: string;
  quantidade: number;
}
interface AtividadeItem {
  descricao: string;
  porcentagem: number;
  status: "Em andamento" | "Concluída" | "Pausada";
}

interface DiarioModalsProps {
  showMaoModal: boolean;
  setShowMaoModal: (v: boolean) => void;
  showEquipModal: boolean;
  setShowEquipModal: (v: boolean) => void;
  showAtvModal: boolean;
  setShowAtvModal: (v: boolean) => void;
  showOcorrModal: boolean;
  setShowOcorrModal: (v: boolean) => void;
  onAddMaoObra: (itens: MaoItem[]) => void;
  onAddEquipamentos: (itens: EquipItem[]) => void;
  onAddAtividade: (atividade: AtividadeItem) => void;
  onAddOcorrencia: (ocorrencia: string) => void;
  existingMaoObra: MaoItem[];
  existingEquipamentos: EquipItem[];
  modoEscuro: boolean;
  saving: boolean;
}

const MAO_OPTIONS: MaoItem[] = [
  { nome: "Ajudante", quantidade: 0 },
  { nome: "Armador", quantidade: 0 },
  { nome: "Carpinteiro", quantidade: 0 },
  { nome: "Ceramista", quantidade: 0 },
  { nome: "Climatização", quantidade: 0 },
  { nome: "Encanador", quantidade: 0 },
  { nome: "Eletricista", quantidade: 0 },
  { nome: "Esquadria", quantidade: 0 },
  { nome: "Estagiario", quantidade: 0 },
  { nome: "Forro", quantidade: 0 },
  { nome: "Gesseiro", quantidade: 0 },
  { nome: "Impermeabilização", quantidade: 0 },
  { nome: "Instalador de Aquecedor", quantidade: 0 },
  { nome: "Instalador de Gás", quantidade: 0 },
  { nome: "Instalador deck e pergolado", quantidade: 0 },
  { nome: "Instalação Piscina", quantidade: 0 },
  { nome: "Instalação de calhas e rufos", quantidade: 0 },
  { nome: "Instalação de dutos", quantidade: 0 },
  { nome: "Jardinheiro", quantidade: 0 },
  { nome: "Limpeza", quantidade: 0 },
  { nome: "M.O. Furações", quantidade: 0 },
  { nome: "Marceneiro", quantidade: 0 },
  { nome: "Marmoraria", quantidade: 0 },
  { nome: "Mestre de Obra", quantidade: 0 },
  { nome: "Pedreiro", quantidade: 0 },
  { nome: "Pintor", quantidade: 0 },
  { nome: "Piso Aquecido", quantidade: 0 },
  { nome: "Piso vinílico", quantidade: 0 },
  { nome: "Portas e Rodapé", quantidade: 0 },
  { nome: "Serralheiro", quantidade: 0 },
  { nome: "Servente", quantidade: 0 },
  { nome: "Sondagem", quantidade: 0 },
  { nome: "Telecom", quantidade: 0 },
  { nome: "Terraplanagem", quantidade: 0 },
  { nome: "Vidraceiro", quantidade: 0 },
  { nome: "Arquiteta", quantidade: 0 },
  { nome: "Engenheiro", quantidade: 0 },
  { nome: "Preventivo de Incêndio", quantidade: 0 },
  { nome: "Técnico em Edificações", quantidade: 0 },
  { nome: "Terceiros", quantidade: 0 },
  { nome: "Comunicação Visual", quantidade: 0 },
  { nome: "Metálica", quantidade: 0 },
  { nome: "Programação visual", quantidade: 0 },
];

const EQUIP_OPTIONS: EquipItem[] = [
  { nome: "Andaime", quantidade: 0 },
  { nome: "Betoneira", quantidade: 0 },
  { nome: "Compactador de solo", quantidade: 0 },
  { nome: "Disco de corte", quantidade: 0 },
  { nome: "Duto de entulho", quantidade: 0 },
  { nome: "Escoras metálicas", quantidade: 0 },
  { nome: "Macaco hidráulico", quantidade: 0 },
  { nome: "Paleteira", quantidade: 0 },
  { nome: "Picareta", quantidade: 0 },
  { nome: "Pá Carregadeira", quantidade: 0 },
  { nome: "Rompedor", quantidade: 0 },
  { nome: "Vibrador", quantidade: 0 },
];

const OCORR_OPTIONS = [
  "Acidente de trabalho",
  "Alteração de projeto",
  "Dia Chuvoso",
  "Dia parado",
  "Falta de equipamento",
  "Falta de material",
  "Falta de mão de obra",
  "Horas Improdutivas",
  "Retrabalho",
  "Solicitação fora do escopo",
  "Solicitações do cliente",
  "Visita de fiscalização",
  "Entrega de material",
  "Problema técnico",
  "Atraso de fornecedor"
];

const DiarioModals: React.FC<DiarioModalsProps> = ({
  showMaoModal, setShowMaoModal,
  showEquipModal, setShowEquipModal,
  showAtvModal, setShowAtvModal,
  showOcorrModal, setShowOcorrModal,
  onAddMaoObra, onAddEquipamentos, onAddAtividade, onAddOcorrencia,
  existingMaoObra, existingEquipamentos,
  modoEscuro, saving
}) => {
  // Estados temporários para seleção
  const [tempMaoSel, setTempMaoSel] = useState<string[]>([]);
  const [tempEquipSel, setTempEquipSel] = useState<string[]>([]);
  
  // Estados para busca/filtro
  const [searchMao, setSearchMao] = useState("");
  const [searchEquip, setSearchEquip] = useState("");
  
  // Estados para nova atividade
  const [novaDesc, setNovaDesc] = useState("");
  const [novaPct, setNovaPct] = useState<number>(0);
  const [novaStatus, setNovaStatus] = useState<"Em andamento" | "Concluída" | "Pausada">("Em andamento");
  
  // Estado para nova ocorrência
  const [tempOcorrInput, setTempOcorrInput] = useState("");

  // Filtrar opções baseado na busca
  const filteredMaoOptions = MAO_OPTIONS.filter(opt => 
    opt.nome.toLowerCase().includes(searchMao.toLowerCase())
  );
  
  const filteredEquipOptions = EQUIP_OPTIONS.filter(opt => 
    opt.nome.toLowerCase().includes(searchEquip.toLowerCase())
  );

  // Atualizar seleções quando modais abrem
  useEffect(() => {
    if (showMaoModal) {
      setTempMaoSel(existingMaoObra.map(m => m.nome));
      setSearchMao("");
    }
  }, [showMaoModal, existingMaoObra]);

  useEffect(() => {
    if (showEquipModal) {
      setTempEquipSel(existingEquipamentos.map(e => e.nome));
      setSearchEquip("");
    }
  }, [showEquipModal, existingEquipamentos]);

  // Handlers para salvar seleção
  function handleSalvarMaoObra() {
    const selecionados = MAO_OPTIONS.filter(o => tempMaoSel.includes(o.nome))
      .map(o => ({ ...o, quantidade: 0 }));
    onAddMaoObra(selecionados);
    setShowMaoModal(false);
    setTempMaoSel([]);
    setSearchMao("");
  }

  function handleSalvarEquip() {
    const selecionados = EQUIP_OPTIONS.filter(o => tempEquipSel.includes(o.nome))
      .map(o => ({ ...o, quantidade: 0 }));
    onAddEquipamentos(selecionados);
    setShowEquipModal(false);
    setTempEquipSel([]);
    setSearchEquip("");
  }

  function handleSalvarAtividade() {
    if (novaDesc.trim()) {
      const nova: AtividadeItem = { 
        descricao: novaDesc.trim(), 
        porcentagem: novaPct, 
        status: novaStatus 
      };
      onAddAtividade(nova);
      setShowAtvModal(false);
      setNovaDesc("");
      setNovaPct(0);
      setNovaStatus("Em andamento");
    }
  }

  function handleSalvarOcorrencia() {
    if (tempOcorrInput.trim()) {
      onAddOcorrencia(tempOcorrInput.trim());
      setShowOcorrModal(false);
      setTempOcorrInput("");
    }
  }

  // Handlers para fechar modais
  function handleFecharMaoModal() {
    setShowMaoModal(false);
    setTempMaoSel([]);
    setSearchMao("");
  }

  function handleFecharEquipModal() {
    setShowEquipModal(false);
    setTempEquipSel([]);
    setSearchEquip("");
  }

  function handleFecharAtvModal() {
    setShowAtvModal(false);
    setNovaDesc("");
    setNovaPct(0);
    setNovaStatus("Em andamento");
  }

  function handleFecharOcorrModal() {
    setShowOcorrModal(false);
    setTempOcorrInput("");
  }

  return (
    <>
      {/* Modal Mão de Obra */}
      {showMaoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className={`rounded-lg overflow-hidden max-h-[85vh] w-full max-w-lg border transition-colors ${modoEscuro ? "bg-gray-800 border-gray-700" : "bg-background border-secondary"}`}>
            {/* Header do Modal */}
            <div className="flex justify-between items-center p-4 border-b border-secondary">
              <h2 className={`text-lg font-ageo-bold transition-colors ${modoEscuro ? "text-gray-100" : "text-foreground"}`}>Selecionar Mão de Obra</h2>
              <button type="button" onClick={handleFecharMaoModal} className={`p-1 transition-colors ${modoEscuro ? "text-gray-400 hover:text-gray-100" : "text-foreground/70 hover:text-foreground"}`}>
                <X className="w-5 h-5" />
              </button>
            </div>
            
            {/* Campo de Pesquisa */}
            <div className="p-4 border-b border-secondary">
              <div className="relative">
                <Search className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 transition-colors ${modoEscuro ? "text-gray-400" : "text-foreground/50"}`} />
                <input
                  type="text"
                  placeholder="Pesquisar mão de obra..."
                  value={searchMao}
                  onChange={(e) => setSearchMao(e.target.value)}
                  className={`w-full pl-10 pr-4 py-3 rounded-md border text-sm font-ageo-regular focus:outline-none focus:ring-2 transition-colors ${modoEscuro ? "border-gray-600 bg-gray-700 text-gray-100 focus:ring-blue-400 placeholder-gray-400" : "border-secondary bg-background text-foreground focus:ring-primary placeholder-foreground/50"}`}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>
            </div>
            
            {/* Lista de Opções */}
            <div className="p-4 overflow-y-auto flex-1" style={{ maxHeight: 'calc(85vh - 200px)' }}>
              {filteredMaoOptions.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {filteredMaoOptions.map((opt) => (
                    <label key={opt.nome} className={`flex items-center space-x-3 p-3 rounded-md cursor-pointer transition-colors hover:bg-opacity-50 ${modoEscuro ? "hover:bg-gray-700/50 text-gray-100" : "hover:bg-secondary/20 text-foreground"}`}>
                      <input 
                        type="checkbox" 
                        className={`h-4 w-4 focus:ring-2 rounded ${modoEscuro ? "text-green-600 focus:ring-blue-400" : "text-confirmation focus:ring-primary"}`} 
                        checked={tempMaoSel.includes(opt.nome)} 
                        onChange={() => setTempMaoSel(t => t.includes(opt.nome) ? t.filter(n => n !== opt.nome) : [...t, opt.nome])} 
                        disabled={saving} 
                      />
                      <span className="text-sm font-ageo-regular flex-1">{opt.nome}</span>
                    </label>
                  ))}
                </div>
              ) : (
                <div className={`text-center py-8 transition-colors ${modoEscuro ? "text-gray-400" : "text-foreground/70"}`}>
                  <p className="text-sm font-ageo-regular">Nenhum item encontrado para "{searchMao}"</p>
                </div>
              )}
            </div>
            
            {/* Footer do Modal */}
            <div className="p-4 border-t border-secondary flex justify-end space-x-3">
              <button type="button" onClick={handleFecharMaoModal} className={`px-4 py-2 border rounded-md text-sm font-ageo-regular transition-colors ${modoEscuro ? "border-gray-600 text-gray-100 hover:bg-gray-700/20" : "border-secondary text-foreground hover:bg-secondary/20"}`} disabled={saving}>
                Fechar
              </button>
              <button type="button" onClick={handleSalvarMaoObra} className={`px-4 py-2 rounded-md text-sm font-ageo-regular transition-colors ${modoEscuro ? "bg-green-600 text-white hover:bg-green-700" : "bg-confirmation text-white hover:bg-confirmation/90"}`} disabled={saving}>
                Salvar ({tempMaoSel.length})
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Equipamentos */}
      {showEquipModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className={`rounded-lg overflow-hidden max-h-[85vh] w-full max-w-lg border transition-colors ${modoEscuro ? "bg-gray-800 border-gray-700" : "bg-background border-secondary"}`}>
            {/* Header do Modal */}
            <div className="flex justify-between items-center p-4 border-b border-secondary">
              <h2 className={`text-lg font-ageo-bold transition-colors ${modoEscuro ? "text-gray-100" : "text-foreground"}`}>Selecionar Equipamentos</h2>
              <button type="button" onClick={handleFecharEquipModal} className={`p-1 transition-colors ${modoEscuro ? "text-gray-400 hover:text-gray-100" : "text-foreground/70 hover:text-foreground"}`}>
                <X className="w-5 h-5" />
              </button>
            </div>
            
            {/* Campo de Pesquisa */}
            <div className="p-4 border-b border-secondary">
              <div className="relative">
                <Search className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 transition-colors ${modoEscuro ? "text-gray-400" : "text-foreground/50"}`} />
                <input
                  type="text"
                  placeholder="Pesquisar equipamentos..."
                  value={searchEquip}
                  onChange={(e) => setSearchEquip(e.target.value)}
                  className={`w-full pl-10 pr-4 py-3 rounded-md border text-sm font-ageo-regular focus:outline-none focus:ring-2 transition-colors ${modoEscuro ? "border-gray-600 bg-gray-700 text-gray-100 focus:ring-blue-400 placeholder-gray-400" : "border-secondary bg-background text-foreground focus:ring-primary placeholder-foreground/50"}`}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>
            </div>
            
            {/* Lista de Opções */}
            <div className="p-4 overflow-y-auto flex-1" style={{ maxHeight: 'calc(85vh - 200px)' }}>
              {filteredEquipOptions.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {filteredEquipOptions.map((opt) => (
                    <label key={opt.nome} className={`flex items-center space-x-3 p-3 rounded-md cursor-pointer transition-colors hover:bg-opacity-50 ${modoEscuro ? "hover:bg-gray-700/50 text-gray-100" : "hover:bg-secondary/20 text-foreground"}`}>
                      <input 
                        type="checkbox" 
                        className={`h-4 w-4 focus:ring-2 rounded ${modoEscuro ? "text-green-600 focus:ring-blue-400" : "text-confirmation focus:ring-primary"}`} 
                        checked={tempEquipSel.includes(opt.nome)} 
                        onChange={() => setTempEquipSel(t => t.includes(opt.nome) ? t.filter(n => n !== opt.nome) : [...t, opt.nome])} 
                        disabled={saving} 
                      />
                      <span className="text-sm font-ageo-regular flex-1">{opt.nome}</span>
                    </label>
                  ))}
                </div>
              ) : (
                <div className={`text-center py-8 transition-colors ${modoEscuro ? "text-gray-400" : "text-foreground/70"}`}>
                  <p className="text-sm font-ageo-regular">Nenhum item encontrado para "{searchEquip}"</p>
                </div>
              )}
            </div>
            
            {/* Footer do Modal */}
            <div className="p-4 border-t border-secondary flex justify-end space-x-3">
              <button type="button" onClick={handleFecharEquipModal} className={`px-4 py-2 border rounded-md text-sm font-ageo-regular transition-colors ${modoEscuro ? "border-gray-600 text-gray-100 hover:bg-gray-700/20" : "border-secondary text-foreground hover:bg-secondary/20"}`} disabled={saving}>
                Fechar
              </button>
              <button type="button" onClick={handleSalvarEquip} className={`px-4 py-2 rounded-md text-sm font-ageo-regular transition-colors ${modoEscuro ? "bg-green-600 text-white hover:bg-green-700" : "bg-confirmation text-white hover:bg-confirmation/90"}`} disabled={saving}>
                Salvar ({tempEquipSel.length})
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Atividades */}
      {showAtvModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className={`rounded-lg overflow-auto max-h-[80vh] w-full max-w-lg p-6 border transition-colors ${modoEscuro ? "bg-gray-800 border-gray-700" : "bg-background border-secondary"}`}>
            <div className="flex justify-between items-center mb-4">
              <h2 className={`text-lg font-ageo-bold transition-colors ${modoEscuro ? "text-gray-100" : "text-foreground"}`}>Adicionar Atividade</h2>
              <button type="button" onClick={handleFecharAtvModal} className={`transition-colors ${modoEscuro ? "text-gray-400 hover:text-gray-100" : "text-foreground/70 hover:text-foreground"}`}>
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="space-y-4">
              <div>
                <label className={`block text-sm font-ageo-regular mb-1 transition-colors ${modoEscuro ? "text-gray-100" : "text-foreground"}`}>Descrição</label>
                <textarea 
                  value={novaDesc} 
                  onChange={(e) => setNovaDesc(e.target.value)} 
                  className={`w-full rounded-md border px-3 py-2 text-sm font-ageo-regular focus:outline-none focus:ring-2 transition-colors ${modoEscuro ? "border-gray-600 bg-gray-700 text-gray-100 focus:ring-blue-400" : "border-secondary bg-background text-foreground focus:ring-primary"}`} 
                  rows={3} 
                  disabled={saving}
                  placeholder="Descreva a atividade realizada..."
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className={`block text-sm font-ageo-regular mb-1 transition-colors ${modoEscuro ? "text-gray-100" : "text-foreground"}`}>Percentual (%)</label>
                  <input 
                    type="number" 
                    value={novaPct} 
                    onChange={(e) => setNovaPct(Number(e.target.value))} 
                    className={`w-full rounded-md border px-3 py-2 text-sm font-ageo-regular focus:outline-none focus:ring-2 transition-colors ${modoEscuro ? "border-gray-600 bg-gray-700 text-gray-100 focus:ring-blue-400" : "border-secondary bg-background text-foreground focus:ring-primary"}`} 
                    min="0" 
                    max="100" 
                    disabled={saving} 
                  />
                </div>
                <div>
                  <label className={`block text-sm font-ageo-regular mb-1 transition-colors ${modoEscuro ? "text-gray-100" : "text-foreground"}`}>Status</label>
                  <select 
                    value={novaStatus} 
                    onChange={(e) => setNovaStatus(e.target.value as any)} 
                    className={`w-full rounded-md border px-3 py-2 text-sm font-ageo-regular focus:outline-none focus:ring-2 transition-colors ${modoEscuro ? "border-gray-600 bg-gray-700 text-gray-100 focus:ring-blue-400" : "border-secondary bg-background text-foreground focus:ring-primary"}`} 
                    disabled={saving}
                  >
                    <option value="Em andamento">Em andamento</option>
                    <option value="Concluída">Concluída</option>
                    <option value="Pausada">Pausada</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-4">
              <button type="button" onClick={handleFecharAtvModal} className={`px-4 py-2 border rounded-md text-sm font-ageo-regular transition-colors ${modoEscuro ? "border-gray-600 text-gray-100 hover:bg-gray-700/20" : "border-secondary text-foreground hover:bg-secondary/20"}`} disabled={saving}>
                Fechar
              </button>
              <button type="button" onClick={handleSalvarAtividade} disabled={!novaDesc.trim() || saving} className={`px-4 py-2 rounded-md text-sm font-ageo-regular disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${modoEscuro ? "bg-green-600 text-white hover:bg-green-700" : "bg-confirmation text-white hover:bg-confirmation/90"}`}>
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Ocorrências */}
      {showOcorrModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className={`rounded-lg overflow-auto max-h-[80vh] w-full max-w-lg p-6 border transition-colors ${modoEscuro ? "bg-gray-800 border-gray-700" : "bg-background border-secondary"}`}>
            <div className="flex justify-between items-center mb-4">
              <h2 className={`text-lg font-ageo-bold transition-colors ${modoEscuro ? "text-gray-100" : "text-foreground"}`}>Adicionar Ocorrência</h2>
              <button type="button" onClick={handleFecharOcorrModal} className={`transition-colors ${modoEscuro ? "text-gray-400 hover:text-gray-100" : "text-foreground/70 hover:text-foreground"}`}>
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="space-y-4">
              <div>
                <label className={`block text-sm font-ageo-regular mb-2 transition-colors ${modoEscuro ? "text-gray-100" : "text-foreground"}`}>
                  Descreva a ocorrência
                </label>
                <textarea 
                  value={tempOcorrInput} 
                  onChange={(e) => setTempOcorrInput(e.target.value)} 
                  className={`w-full rounded-md border px-3 py-2 text-sm font-ageo-regular focus:outline-none focus:ring-2 transition-colors ${modoEscuro ? "border-gray-600 bg-gray-700 text-gray-100 focus:ring-blue-400" : "border-secondary bg-background text-foreground focus:ring-primary"}`} 
                  rows={4} 
                  placeholder="Digite aqui a ocorrência do dia..." 
                  disabled={saving} 
                />
              </div>
              
              <div>
                <p className={`text-sm font-ageo-regular mb-2 transition-colors ${modoEscuro ? "text-gray-100" : "text-foreground"}`}>Ocorrências comuns:</p>
                <div className="grid grid-cols-1 gap-2 max-h-40 overflow-y-auto">
                  {OCORR_OPTIONS.map((opcao) => (
                    <button 
                      key={opcao} 
                      type="button" 
                      onClick={() => setTempOcorrInput(opcao)} 
                      className={`text-left px-3 py-2 text-sm rounded-md font-ageo-regular transition-colors ${modoEscuro ? "bg-gray-700/50 hover:bg-gray-600/50 text-gray-100" : "bg-secondary/20 hover:bg-secondary/40 text-foreground"}`} 
                      disabled={saving}
                    >
                      {opcao}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-4">
              <button type="button" onClick={handleFecharOcorrModal} className={`px-4 py-2 border rounded-md text-sm font-ageo-regular transition-colors ${modoEscuro ? "border-gray-600 text-gray-100 hover:bg-gray-700/20" : "border-secondary text-foreground hover:bg-secondary/20"}`} disabled={saving}>
                Fechar
              </button>
              <button type="button" onClick={handleSalvarOcorrencia} disabled={!tempOcorrInput.trim() || saving} className={`px-4 py-2 rounded-md text-sm font-ageo-regular disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${modoEscuro ? "bg-green-600 text-white hover:bg-green-700" : "bg-confirmation text-white hover:bg-confirmation/90"}`}>
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DiarioModals;